import { LiteralType, QueryExprSyntaxTree } from "src/app/services/api.services";
import { LiteralSyntax, SyntaxNode, SyntaxSpan } from "./Syntax";

export function createSyntaxTree(root: SyntaxNode): QueryExprSyntaxTree {
  return {
    root
  };
}

export function createStringLiteralSyntaxTree(value: string): QueryExprSyntaxTree {
  return createLiteralSyntaxTree(LiteralType.String, value);
}

export function createLiteralSyntaxTree(type: LiteralType, value: any): QueryExprSyntaxTree {
  return createSyntaxTree(createLiteralSyntax(type, value));
}

export function createLiteralSyntax(type: LiteralType, value: any): LiteralSyntax {
  return new LiteralSyntax(
    SyntaxSpan.empty,
    type,
    value
  );
}
